import { Box } from '@modusign/design-system';

import { createAbsoluteSize } from '@app/features/apply-react-signing/components/FieldRenderer/libs/createAbsoluteSize';
import { ReactSigningConfigurationFieldRenderer } from '@app/features/apply-react-signing/components/FieldRenderer/Setup/FieldRenderers';

interface PDFTemplateBusinessPageProps {
  pageNumber: number;
  scale: number;
  viewport: {
    height: number;
    width: number;
  };
}

function PDFDraftPreviewBusinessPage({
  pageNumber,
  scale,
  viewport,
}: PDFTemplateBusinessPageProps) {
  const absoluteViewport = createAbsoluteSize(viewport);

  return (
    <Box height="100%" position="absolute" width="100%">
      <ReactSigningConfigurationFieldRenderer
        initialContextMenuOpened
        isPreview
        page={pageNumber}
        readOnly
        scale={scale}
        viewport={absoluteViewport}
      />
    </Box>
  );
}

export default PDFDraftPreviewBusinessPage;
